import Big, { type BigSource } from "big.js";

export function isBigInstance(value: unknown): value is Big {
  return value instanceof Big;
}

export function toBig(value: BigSource, fallback: BigSource = "0"): Big {
  if (isBigInstance(value)) {
    return value;
  }

  if (typeof value === "string" || typeof value === "number") {
    try {
      const valueBig = new Big(value);

      return valueBig;
    } catch (_) {
      console.error("Failed to parse value to Big:", value);

      return isBigInstance(fallback) ? fallback : new Big(fallback);
    }
  }

  return isBigInstance(fallback) ? fallback : new Big(fallback);
}
